import { Link } from "react-router";

import scoreSvg from "../assets/score.svg";
import successSvg from "../assets/success.svg";

export const PrefetchComponent = () => {
  return (
    <>
      <Link prefetch="render" to={scoreSvg} />
      <Link prefetch="render" to={successSvg} />
    </>
  );
};
